export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M13.39 2.1l.78.78c.21.2.33.48.33.78v7.24c0 .61-.5 1.1-1.11 1.1H5.61C5 12 4.5 11.51 4.5 10.9V2.1C4.5 1.49 5 1 5.61 1h6.21c.29 0 .57.12.78.32l.79.78zm0 8.9l.11-.1V4.3h-1.85c-.27 0-.48-.21-.48-.47V2H5.61l-.11.1v8.8l.11.1h7.78z\" clip-rule=\"evenodd\"/><path d=\"M2.5 14h9v.31c0 .38-.31.69-.69.69H2.19c-.38 0-.69-.31-.69-.69V4.69c0-.38.31-.69.69-.69h.31v10z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};